import { LinearAxis } from './axis';
/**
 * LinearAxis component bind to y scale.
 */
export const AxisY = (options) => {
    return LinearAxis(options);
};
AxisY.props = Object.assign(Object.assign({}, LinearAxis.props), { defaultPosition: 'left' });
//# sourceMappingURL=axisY.js.map